import axios from "axios";
import {
  FETCH_BOOKEDSERVICES_SUCCESS,
  FETCH_BOOKEDSERVICES_FAILURE,
} from "../actionTypes";

const Base_Url = process.env.REACT_APP_BASE_URL;

export const fetchBookedServices = () => {
  return async (dispatch) => {
    try {
      const token=localStorage.getItem("token");
      const res = await axios.get(`${Base_Url}/api/bookedService/getBookedServiceForCustomers`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      dispatch({
        type: FETCH_BOOKEDSERVICES_SUCCESS,
        payload: {
          bookedservices: Array.isArray(res.data.data) ? res.data.data : [],
          message: res.data.message || "Booked Services fetched successfully",
        },
      });
    } catch (err) {
      dispatch({
        type: FETCH_BOOKEDSERVICES_FAILURE,
        payload: err.response?.data?.message || err.message,
      });
    }
  };
};
